import React, { useEffect, useState } from 'react';

const GlowingOrb = () => {
  const [position, setPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const orbStyle = {
    position: 'fixed',
    top: position.y,
    left: position.x,
    transform: 'translate(-50%, -50%)',
    width: '250px',
    height: '250px',
    borderRadius: '50%',
    background: 'radial-gradient(circle at center, #00ffe0, #00ffe000)',
    filter: 'blur(70px)',
    opacity: 0.7,
    animation: 'pulse 5s ease-in-out infinite',
    zIndex: -1,
    pointerEvents: 'none',
  };

  return (
    <>
      <div style={orbStyle}></div>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 0.5;
            }
            50% {
              transform: translate(-50%, -50%) scale(1.15);
              opacity: 0.8;
            }
          }
        `}
      </style>
    </>
  );
};

export default GlowingOrb;
